// Mock data for Humanity Care College of Higher Studies

export const collegeInfo = {
  name: "Humanity Care College of Higher Studies",
  shortName: "Humanity Care",
  tagline: "College of Higher Studies",
  established: "2012",
  phone1: "7766909527",
  phone2: "9525702020",
  displayEmail: "surendraml@gmail.com",
  applyEmail: "educafirst1@gmail.com",
  whatsapp: "917766909527",
  whatsappMsg: "Hello! I am interested in admission to Humanity Care College of Higher Studies. Please share more details.",
  address: "Ramdayalu Nagar Bhikanpur Dih, Hajipur Road, Near Ramdayalu Railway Crossing, Muzaffarpur, Bihar 842002",
  mapUrl: "https://share.google/VB3fyBH0lzgzsKyvk",
  officeHours: {
    weekdays: "Mon - Sat: 9:00 AM - 5:00 PM",
    sunday: "Sunday: Closed"
  },
  affiliations: [
    "Recognized Institute for Higher Studies",
    "Affiliated with Reputed Universities",
    "Approved by Government of Bihar"
  ]
};

export const heroImage = "https://images.unsplash.com/photo-1741637335289-c99652d3155f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxjb2xsZWdlJTIwc3R1ZGVudHMlMjBjYW1wdXN8ZW58MHx8fHwxNzgxNzg2MzUzfDA&ixlib=rb-4.1.0&q=85";

export const galleryImages = [
  {
    id: "g-classroom",
    url: "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwY2xhc3Nyb29tfGVufDB8fHx8MTc4MTc4NjM1Mnww&ixlib=rb-4.1.0&q=85",
    caption: "Modern Classrooms"
  },
  {
    id: "g-graduation",
    url: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxncmFkdWF0aW9uJTIwY2VyZW1vbnl8ZW58MHx8fHwxNzgxNjExODI1fDA&ixlib=rb-4.1.0&q=85",
    caption: "Graduation Day"
  },
  {
    id: "g-lab",
    url: "https://images.pexels.com/photos/5530484/pexels-photo-5530484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Computer Lab"
  },
  {
    id: "g-learning",
    url: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHx1bml2ZXJzaXR5JTIwY2xhc3Nyb29tfGVufDB8fHx8MTc4MTc4NjM1Mnww&ixlib=rb-4.1.0&q=85",
    caption: "Interactive Learning"
  },
  {
    id: "g-campus",
    url: "https://images.unsplash.com/photo-1741637335289-c99652d3155f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxjb2xsZWdlJTIwc3R1ZGVudHMlMjBjYW1wdXN8ZW58MHx8fHwxNzgxNzg2MzUzfDA&ixlib=rb-4.1.0&q=85",
    caption: "Campus Life"
  },
  {
    id: "g-tech",
    url: "https://images.pexels.com/photos/5530484/pexels-photo-5530484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Technology Labs"
  }
];

export const courses = [
  {
    code: "BBA",
    name: "Bachelor of Business Administration",
    type: "Degree Program",
    duration: "3 Years",
    mode: "Regular",
    eligibility: "10+2 (Any stream)",
    description: "Comprehensive business education covering management, marketing, finance, and entrepreneurship for future business leaders.",
    highlights: ["Industry-aligned curriculum", "Internship opportunities", "Case study based learning", "Soft skills development"]
  },
  {
    code: "BCA",
    name: "Bachelor of Computer Applications",
    type: "Degree Program",
    duration: "3 Years",
    mode: "Regular",
    eligibility: "10+2 with Mathematics",
    description: "Build a strong foundation in computer science, programming, and software development to excel in the IT industry.",
    highlights: ["Modern computer labs", "Programming in Python, Java, C++", "Web & app development", "Industry projects"]
  },
  {
    code: "BJMC",
    name: "Bachelor of Journalism & Mass Communication",
    type: "Degree Program",
    duration: "3 Years",
    mode: "Regular",
    eligibility: "10+2 (Any stream)",
    description: "Develop expertise in print, broadcast and digital media. Become an impactful journalist and storyteller.",
    highlights: ["Media lab access", "Field reporting practice", "Video & audio production", "Industry mentors"]
  },
  {
    code: "BLIS",
    name: "Bachelor of Library and Information Science",
    type: "Degree Program",
    duration: "1 Year",
    mode: "Regular",
    eligibility: "Graduation in any discipline",
    description: "Specialized program in library management, cataloguing, classification and information systems.",
    highlights: ["Practical library training", "Digital library systems", "Cataloguing & classification", "Research methodology"]
  },
  {
    code: "DOL",
    name: "Diploma in Oriental Librarianship",
    type: "Diploma Program",
    duration: "1 Year",
    mode: "Regular",
    eligibility: "10+2 / Graduation",
    description: "Specialized diploma focused on managing oriental manuscripts, classical texts, and traditional library systems.",
    highlights: ["Manuscript preservation", "Oriental cataloguing", "Research techniques", "Heritage knowledge"]
  },
  {
    code: "APRI",
    name: "Accountancy for Panchayti Raj Institutions",
    type: "Certificate Program",
    duration: "6 Months",
    mode: "Regular",
    eligibility: "10+2 / Graduation",
    description: "Specialized accountancy course tailored for Panchayati Raj Institutions, covering rural governance finance.",
    highlights: ["Government accounting", "PRI financial systems", "Audit procedures", "Practical training"]
  },
  {
    code: "FA",
    name: "Functional Arabic",
    type: "Certificate Program",
    duration: "1 Year",
    mode: "Regular",
    eligibility: "10+2 / Graduation",
    description: "Practical Arabic language program with focus on reading, writing and conversational skills for real-world use.",
    highlights: ["Conversational Arabic", "Reading & writing skills", "Cultural insights", "Career opportunities abroad"]
  },
  {
    code: "FP",
    name: "Functional Persian",
    type: "Certificate Program",
    duration: "1 Year",
    mode: "Regular",
    eligibility: "10+2 / Graduation",
    description: "Comprehensive Persian language program covering script, grammar and conversational competence.",
    highlights: ["Persian script mastery", "Conversational Persian", "Literature exposure", "Cultural studies"]
  }
];

export const notices = [
  { id: 1, title: "Admissions Open for 2025-26 Academic Session", date: "July 2025", urgent: true },
  { id: 2, title: "Last date to apply for BBA & BCA: 30th August 2025", date: "July 2025", urgent: true },
  { id: 3, title: "Scholarship applications now being accepted", date: "July 2025", urgent: false },
  { id: 4, title: "Orientation programme for new students scheduled", date: "July 2025", urgent: false }
];

export const stats = [
  { value: "100%", label: "Placement Assistance" },
  { value: "1000+", label: "Students Enrolled" },
  { value: "Since 2012", label: "Empowering Students" }
];

export const features = [
  {
    title: "Experienced Faculty",
    description: "Learn from highly qualified and experienced professors with years of academic and industry expertise."
  },
  {
    title: "Modern Infrastructure",
    description: "State-of-the-art classrooms, computer labs, library and campus facilities for holistic learning."
  },
  {
    title: "Career Support",
    description: "Dedicated placement cell with strong industry network for internships and job placement assistance."
  },
  {
    title: "Diverse Programs",
    description: "Wide range of courses from management and computer applications to languages and traditional studies."
  },
  {
    title: "Scholarship Programs",
    description: "Merit and need-based scholarships available for deserving students to support their education."
  },
  {
    title: "Holistic Development",
    description: "Beyond academics — sports, cultural events, seminars and co-curricular activities for overall growth."
  }
];
